import { loadable } from 'utils';

export const Composition = loadable(() => import('./Composition'), {});
export const Information = loadable(() => import('./Information'), {});
export const Kit = loadable(() => import('./Kit'), {});
export const Options = loadable(() => import('./Options'), {});
export const PaymentMethods = loadable(() => import('./PaymentMethods'), {});
export const Price = loadable(() => import('./Price'), {});
